module.exports = __webpack_public_path__ + "ov_3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/contact/ov/ov_3.jpg
// module id = 874
// module chunks = 0